import { Columns, ConditionalContent } from '@domain-group/suit-theme'

import useAgency from '@hooks/useAgency'

import MessagePanel from '@components/MessagePanel'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import PageLayout from '../../../../components/PageLayout'

import AddressDetails from '../AddressDetails'
import BrandDetails from '../BrandDetails'
import AgencyDetails from '../AgencyDetails'
import ContactDetails from '../ContactDetails'
import PrincipalDetails from '../PrincipalDetails'

interface PageContentProps {
  agencyId: number,
}

const PageContent = (props: PageContentProps) => {
  const { agencyId } = props

  const agencyPayload = useAgency({ id: agencyId })
  const { agency, agencySalesforceDetails } = agencyPayload

  return (
    <PageLayout activeTabBarItemKey="salesforceDetails" entityPayload={agencyPayload}>
      <Columns.Main>
        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          <ConditionalContent visible={!agency?.zuora_account_number}>
            <MessagePanel
              description={`This agency does not have a Zuora Account Number stored
                                        which means no invoices can be generated against this agency. If
                                        this agency should be invoiced for any reason, please have the
                                        agency added to Salesforce. Reach out to the Realhub Onboarding 
                                        Specialist team to correctly link this account to Salesforce & Zuora.`}
              entityProperty
              marginBottom="large"
              title="Non Billable Agency"
            />
          </ConditionalContent>
        </ScopedConditionalContent>

        <BrandDetails agencySalesforceDetails={agencySalesforceDetails} />

        <AgencyDetails agencySalesforceDetails={agencySalesforceDetails} />

        <ContactDetails agencySalesforceDetails={agencySalesforceDetails} />

        <PrincipalDetails agencySalesforceDetails={agencySalesforceDetails} />

        <AddressDetails agencySalesforceDetails={agencySalesforceDetails} />
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
